import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { finalize } from 'rxjs/operators';


export interface UploadResult {
  progress$: Observable<number>;
  downloadUrl$: Observable<string>;
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private app = initializeApp(environment.firebase);
  private auth = getAuth(this.app);

  async initFirebase() {
    try {
      await signInAnonymously(this.auth);
      console.log('Firebase auth ok');
    } catch (e) {
      console.error(e);
    }
  }
  
  private storage = getStorage(this.app);

  constructor(private oauthService: OAuthService) {
    this.initFirebase();
  }

  getFileName(): string {
    let user = "anonymous";
    if (this.oauthService.hasValidAccessToken()) {
        const claims: any = this.oauthService.getIdentityClaims();
        if (claims) {
            if ('sub' in claims) {
                user = `${claims['sub']}`;
            }
        }
    }

    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const yyyy = now.getFullYear();
    const MM = pad(now.getMonth() + 1);
    const dd = pad(now.getDate());
    const hh = pad(now.getHours());
    const mm = pad(now.getMinutes());
    const ss = pad(now.getSeconds());
    const tz = 'Z'; // UTC indicator, adjust if needed

    let fileName = `Eakte+ UI ERROR Report - [${environment.production ? "PROD" : "UAT"} ${environment}] - ${yyyy}${MM}${dd}${tz}${hh}${mm}${ss}- [${user}] - error.txt`;        
    return fileName;
  }

  uploadText(content: string): UploadResult {
    // Convert text to Blob
    const blob = new Blob([content], { type: 'text/plain' });
    const fileName = this.getFileName();

    const storageRef = ref(this.storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, blob);

    const progress$ = new Observable<number>(observer => {
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          observer.next(progress);
        },
        (error) => observer.error(error),
        () => observer.complete()
      );
    });

    const downloadUrl$ = new Observable<string>(observer => {
      uploadTask.on('state_changed',
        null,
        (error) => observer.error(error),
        async () => {
          const url = await getDownloadURL(storageRef);
          console.log('Report file available at', url);
          observer.next(url);
          observer.complete();
        }
      );
    });

    return { progress$, downloadUrl$ };
  }
}
